import { apiUrl } from "helpers/constants/config.constants";
import { httpGet, httpPatch, httpPost } from "./http.service";
import { AxiosResponse } from "axios";
import { ShortUrl } from "./project.service";

export interface User {
  userId: string
  username: string
  name: string
  email: string
  phoneNo: string
  address?: string
  country?: string
  currency?: string
  role: string
  lastLogin: Date | null
}

export interface Setting {
  settingId: string
  projectId: string
  type: string
  code: string
  value: string
  description: string
  level: number
  class: string
  isFinal: boolean
}

export const listUser = (skip: number) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpGet(apiUrl.user.list, { skip });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const getUserDetail = (userId: string) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpGet(apiUrl.user.get(userId));
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const createUser = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpPost(apiUrl.user.create, { ...params });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export const doUpdateUser = (params: Record<string, unknown>) => {
  return new Promise((resolve, reject) => {
    try {
      const response = httpPatch(apiUrl.user.update(params.userId as string), { ...params });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export function doGenerateResetPasswordLink(userId: string): Promise<ShortUrl> {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.shortUrl.resetPassword(userId), {}).then((res: any) => {
      const response = res as AxiosResponse
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}